import { useState, useEffect } from "react";
import axios from "axios";
import "./styles/admadd.scss";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { add, add_count, add_page } from '../../components/apipath';
import { switchHelper, dateHelper } from "../../modules/helpers";
import { ColGroup } from "../../components/ColGroup.js";

function AddRequestRow({
  request,
  editingRequest,
  updatedData,
  startEditing,
  handleInputChange,
  saveChanges,
  setEditingRequest,
  colSpan = 8,
}) {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((v) => !v);

  const isEditing = editingRequest && editingRequest.add_id === request.add_id;

  return (
    <>
      <tr
            onClick={!isEditing ? toggle : undefined}
            style={
                !isEditing
                    ? {
                        cursor: "pointer",
                        transition: "background-color .2s",
                    }
                    : {}
            }
            className={!isEditing ? "table-row-hover" : ""}
        >
        {isEditing ? (
          <>
            <td colSpan={colSpan-1}>
              <div className="container-fluid">
                <div className="row g-2">
                  <div className="col-md-4">
                    <div className="input-group input-group-sm">
                      <span className="input-group-text">申請狀態</span>
                      <select
                        className="form-select"
                        name="status"
                        value={updatedData.status || "審核中"}
                        onChange={handleInputChange}
                      >
                        <option value="審核中">審核中</option>
                        <option value="完成">完成</option>
                        <option value="取消">取消</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-8">
                    <div className="input-group input-group-sm">
                      <span className="input-group-text">備註</span>
                      <textarea
                        className="form-control"
                        rows={3}
                        name="memo"
                        value={updatedData.memo ?? ""}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </td>

            <td>
              <button
                className="btn btn-primary btn-sm m-1"
                onClick={(e) => {
                    e.stopPropagation();
                    saveChanges();
                }}
                >
                保存
                </button>

                <button
                className="btn btn-secondary btn-sm m-1"
                onClick={(e) => {
                    e.stopPropagation();
                    setEditingRequest(null);
                }}
                >
                取消
              </button>
            </td>
          </>
        ) : (
          <>
            <td>
                <a
                    href={`/adm/admmemberedit/${request.mem_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                >
                    {request.student_name}
                </a>
            </td>
            <td title={request.add_on_items_name}>
            {request.add_on_items_name}
            </td>
            <td>{request.status}</td>
            <td>{request.total_amount}</td>
            <td>{request.created_at?.slice(0, 10)}</td>

            <td>
              {request.memo?.split(" | ").map((line, idx) => (
                <div key={idx}>{line}</div>
              ))}
            </td>

            <td>
              <button
                className="btn btn-primary btn-sm m-1"
                onClick={(e) => {
                    e.stopPropagation();
                    startEditing(request);
                }}
                >
                編輯
              </button>
            </td>
          </>
        )}
      </tr>

      {!isEditing && open && (
        <tr className="table-light">
          <td colSpan={colSpan}>
            <div className="row g-2 small">
              <div className="col-md-3">
                <strong>寄送地址：</strong>
                {request.address || "-"}
              </div>

              <div className="col-md-3">
                <strong>發票：</strong>
                {
                request.invoice === "personal"
                    ? "個人"
                    : request.invoice === "company"
                    ? "公司"
                    : request.invoice || "-"
                }
              </div>

              <div className="col-md-3">
                <strong>抬頭：</strong>
                {request.company_name || "-"}
              </div>

              <div className="col-md-3">
                <strong>統編：</strong>
                {request.company_tax || "-"}
              </div>

              <div className="col-md-3">
                <strong>匯款時間：</strong>
                {dateHelper(request.remit_time, "date") || "-"}
              </div>

              <div className="col-md-3">
                <strong>匯款姓名：</strong>
                {request.remit_name || "-"}
              </div>

              <div className="col-md-3">
                <strong>寄送方式：</strong>
                {
                request.deliver === "yes"
                    ? "快遞"
                    : request.deliver === "no"
                    ? "自取"
                    : request.deliver || "-"
                }
              </div>
              <div className="col-md-3">
                <strong>海外號碼：</strong>
                {request.overseas_phone || "-"}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
function AddRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    // const navigate = useNavigate();
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState({
        name: '',
        status: '',
        start: '',
        end: ''
    });
    
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const params = {
                studentName: search.name || '',
                status: search.status || '',
                startDate: search.start || '',
                endDate: search.end || '',
                page: page - 1,
                rows
            };
            const response = await axios.get(`${add_page(page - 1, rows)}`, {
                headers: { token },
                params
            });
            setRequestList(response.data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };
    
    const fetchPageData = async () => {
        try {
            const params = {
                studentName: search.name || '',
                status: search.status || '',
                startDate: search.start || '',
                endDate: search.end || ''
            };
            const response = await axios.get(`${add_count}`, {
                headers: { token },
                params
            });
            setRowsCount(response.data?.[0]?.total || 0);
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);
    
    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    // 開始編輯
    const startEditing = (requestList) => {
        setEditingRequest(requestList);
        setUpdatedData(requestList);
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)) {
            setUpdatedData({
                add_id: editingRequest.add_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else {
            setUpdatedData({
                add_id: editingRequest.add_id,
                ...updatedData,
                [name]: value,
            });
        }
    };

    
    
    // 更新申請記錄
    const saveChanges = async () => {
        try {
            const dataToSend = {
                add_id: updatedData.add_id,
                mem_id: updatedData.mem_id,
                add_on_items: updatedData.add_on_items,
                deliver: updatedData.deliver,
                address: updatedData.address,
                invoice: updatedData.invoice,
                address: updatedData.address,
                company_name: updatedData.company_name,
                company_tax: updatedData.company_tax,
                remit_name: updatedData.remit_name,
                memo: updatedData.memo || '',
                total_amount: updatedData.total_amount,
                status: updatedData.status || '審核中',
            };
    
            console.log("更新送出的資料:", dataToSend);
    
            const response = await axios.put(`${add}`, dataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token
                  }
            });
    
            setRequestList(prevList =>
                prevList.map(req =>
                    req.add_id === updatedData.add_id ? response.data : req
                )
            );
    
        } catch (error) {
            console.error("更新失敗:", error);
        }
    };

    const colWeights = [1, 3, 1, 1, 1, 3, 1];


    return (
        <>
            <div className="mt100 container-fluid p-5">
                <div className="mt-2">
                    <div className="row mb-3">
                    <div className="col-md-2 mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="學生姓名"
                            value={search.name}
                            onChange={(e) => setSearch({ ...search, name: e.target.value })}
                        />
                    </div>
                    <div className="col-md-2 mb-2">
                        <select
                            className="form-control"
                            value={search.status}
                            onChange={(e) => setSearch({ ...search, status: e.target.value })}
                        >
                            <option value="">全部狀態</option>
                            <option value="審核中">審核中</option>
                            <option value="完成">完成</option>
                            <option value="取消">取消</option>
                        </select>
                    </div>
                    <div className="col-md-2 mb-2">
                        <input
                            type="date"
                            className="form-control"
                            value={search.start}
                            onChange={(e) => setSearch({ ...search, start: e.target.value })}
                        />
                    </div>
                    <div className="col-md-2 mb-2">
                        <input
                            type="date"
                            className="form-control"
                            value={search.end}
                            onChange={(e) => setSearch({ ...search, end: e.target.value })}
                        />
                    </div>
                    <div className="col-md-2 mb-2">
                        <button className="btn btn-primary w-100" onClick={() => {
                            setPage(1);
                            fetchPageData();
                            fetchData(1);
                        }}>
                            搜尋
                        </button>
                    </div>
                </div>
                    <table className="table table-striped border table-fixed w-100">
                        <ColGroup weights={colWeights} />
                        <thead>
                            <tr>
                                <th>學生姓名</th>
                                <th>加購項目</th>
                                <th>申請狀態</th>
                                <th>總金額</th>
                                <th>申請日期</th>
                                <th>備註</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requestList.map((request) => (
                                <AddRequestRow
                                key={request.add_id}
                                request={request}
                                editingRequest={editingRequest}
                                updatedData={updatedData}
                                startEditing={startEditing}
                                handleInputChange={handleInputChange}
                                saveChanges={saveChanges}
                                setEditingRequest={setEditingRequest}
                                colSpan={7}
                                />
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-center align-items-center my-3">
                        <button className="btn btn-outline-secondary me-2" disabled={page <= 1}
                            onClick={() => {
                                setPage(prev => prev - 1);
                                fetchData(page - 1);
                            }}>
                            上一頁
                        </button>
                        <span>第 {page} 頁 / 共 {Math.ceil(rowsCount / 50)} 頁</span>
                        <button className="btn btn-outline-secondary ms-2"
                            disabled={page >= Math.ceil(rowsCount / 50)}
                            onClick={() => {
                                setPage(prev => prev + 1);
                                fetchData(page + 1);
                            }}>
                            下一頁
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddRequest;
